import getBackendURL from "../api/api";
import { request } from "../request";
import { Thread } from "../types/data";
import { ESRThunkAction, fetchESRResponses } from "./form";

export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const LIST_MESSAGES = "LIST_MESSAGES";
export const LIST_ALL_MESSAGES = "LIST_ALL_MESSAGES";
export const LIST_FILTERED_MESSAGES = "LIST_FILTERED_MESSAGES";
export const UNREAD_MESSAGES_COUNT = "UNREAD_MESSAGES_COUNT";
export const LIST_SENT_NOTIFICATIONS = "LIST_SENT_NOTIFICATIONS";
export const SET_NEW_NOTIFICATIONS = "SET_NEW_NOTIFICATIONS";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const GET_GROUP_LIST = "GET_GROUP_LIST";
export const LIST_ALL_USERS = "LIST_ALL_USERS";
export const REMOVE_USER_FROM_GROUP = "REMOVE_USER_FROM_GROUP";
export const ADD_USER_TO_GROUPS = "ADD_USER_TO_GROUPS";
export const UPDATE_USER_APPROVAL = "UPDATE_USER_APPROVAL";
export const UPDATE_USER_ADMIN = "UPDATE_USER_ADMIN";
export const FAB_LOADING_THREADS_START = "FAB_LOADING_THREADS_START";
export const FAB_LOADING_THREADS_END = "FAB_LOADING_THREADS_END";


export function createMessage(
	esr_id: string,
	subject: string,
	recipients: string[],
	groups: string[],
	contents: string,
	question_id?: string,
	file_ids?: string[],
): ESRThunkAction | any {
	return (dispatch) => {
		dispatch({
			type: "SEND_MESSAGE_IN_PROGRESS",
		});
		const url = getBackendURL("/esr/send_message/");
		request
			.post(url, {
				esr_id,
				subject: question_id ? `[${question_id}] ${subject}` : subject,
				recipients,
				groups,
				contents,
				question_id: question_id ? question_id : undefined,
				file_ids: file_ids ?? [],
			})
			.then(({ data }) => {
				dispatch(fetchESRResponses(esr_id));
				dispatch(listMessages(esr_id));
				dispatch({
					type: "SEND_MESSAGE_PROGRESS_COMPLETE",
				});
				dispatch({
						type: "SEND_MESSAGE_COMPLETE",
				});
			});
	};
}

export function sendReply(
	esr_id: string,
	thread_id: number,
	contents: string,
	file_ids: string[],
): ESRThunkAction | any {
	return (dispatch) => {
		dispatch({
			type: "SEND_MESSAGE_IN_PROGRESS",
		});
		const url = getBackendURL("/esr/send_message/");
		request
			.post(url, {
				esr_id,
				thread_id,
				contents,
				file_ids,
			})
			.then(({ data }) => {
				dispatch(listMessages(esr_id));
				dispatch({
					type: "SEND_MESSAGE_PROGRESS_COMPLETE",
				});
				setTimeout(() => {
					dispatch({
						type: "SEND_MESSAGE_COMPLETE",
					});
				}, 2000);

			});
	};
}

export function listMessages(esrId: string): ESRThunkAction {
	return (dispatch) => {
		dispatch({
			type: "UPDATE_DRAWER_STATE",
			update: {
				threadsLoading: true,
			},
		});

		const url = getBackendURL("/esr/messages/?esr_id=" + esrId);
		request(url)
			.then(({ data }) => {
				dispatch({
					type: LIST_MESSAGES,
					messages: data,
				});
			})
			.then(() => {
				dispatch(listAllUnresolvedAndUnreadThreads());
			})
			.finally(() => {
				dispatch({
					type: "UPDATE_DRAWER_STATE",
					update: {
						threadsLoading: false,
					},
				});
			});
	};
}

export function listAllMessages(page: number, searchString?:string, unread?: boolean,): ESRThunkAction {
	return (dispatch) => {
		const search = searchString ?? "";
		let url = getBackendURL("/esr/allmessages/?page=" + page);
		if(search?.length > 0){
			url += "&searchString="+search;
		}
		if(unread) url += "&unread="+unread;

		request(url).then(({ data }) => {
			dispatch({
				type: LIST_ALL_MESSAGES,
				messages: data.results,
				count: data.count,
				page: data.page,
				pageSize: data.page_size,
				totalPages: data.total_pages,
			});
		});
	};
}

/**
 * This function is used to list all the
 * removed count of Unresolved threads
 * threads with unread messages
 * for the FAB message icon available across pages
 */
export function listAllUnresolvedAndUnreadThreads(): ESRThunkAction {
	return (dispatch) => {
		// const url = getBackendURL("/esr/messages/?unread=true&esr_id=");
		const url = getBackendURL("/esr/unread_messages/");
		request(url).then(({ data }) => {
			let unread_message_count = data["total_unread_message_count"]
			return dispatch({
				type: UNREAD_MESSAGES_COUNT,
				unread_message_count : unread_message_count,
			});
			// let filtered_threads = Object.values(data as Record<number, Thread>)
			// 	.filter((thread) => thread.unread_messages > 0)
			// 	.map((thread) => thread);
			// return dispatch({
			// 	type: LIST_FILTERED_MESSAGES,
			// 	filtered_threads,
			// });
		});
	};
}

export function viewAllUnresolvedAndUnreadThreads(): ESRThunkAction {
	return (dispatch) => {
		// const url = getBackendURL("/esr/messages/?unread=true&esr_id=");
		dispatch({ type: FAB_LOADING_THREADS_START });
		const url = getBackendURL("/esr/unread_messages/?view_messages=true");
		request(url).then(({ data }) => {
			// return dispatch({
			// 	type: UNREAD_MESSAGES_COUNT,
			// 	unread_message_count : unread_message_count,
			// });
			let filtered_threads = Object.values(data["unread_messages"] as Record<number, Thread>)
				.filter((thread) => thread.unread_messages > 0)
				.map((thread) => thread);
			dispatch({
				type: LIST_FILTERED_MESSAGES,
				filtered_threads,
			});
		})
		.finally(() => {
			dispatch({ type: FAB_LOADING_THREADS_END });
		});

	};
}

/**
 * Function to add a viewer into viewers list of a message
 * Useful to get the number of unread messages
 * @param messageId
 * @param esrId
 */
export function addUserToMessageViewedList(
	messageId: number,
	esrId: string,
): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/esr/message_viewer/");
		request
			.post(url, {
				messageId,
			})
			.then(() => dispatch(listMessages(esrId)));
	};
}

/**
 * Function to remove a viewer from viewers list of a message
 * Useful for user to revisit a message later
 * @param messageId
 * @param esrId
 */
export function deleteUserFromMessageViewedList(
	messageId: number,
	esrId: string,
): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/esr/remove_viewer/");
		request
			.post(url, {
				messageId,
			})
			.then(() => dispatch(listMessages(esrId)));
	};
}

export function listAllSentNotifications(esrId: string): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL("/esr/sent_notifications/");
		request
			.get(url, {
				params: { esrId: esrId },
			})
			.then(({ data }) => {
				return dispatch({
					type: LIST_SENT_NOTIFICATIONS,
					sent_notifications: data.data,
				});
			});
	};
}

export function updateThread(
	esrId: string,
	threadId: number,
	update: {
		resolved?: boolean;
		recipients?: string[];
		groups?: string[];
	},
): ESRThunkAction {
	return (dispatch) => {
		const url = getBackendURL(`/esr/threads/${threadId}`);
		request.patch(url, update).then(() => {
			dispatch(fetchESRResponses(esrId));
			dispatch(listMessages(esrId));
		});
	};
}

export const isValidId = (id?: string):boolean => typeof id === "string" && id.trim() !== "" && !!id && id !== "undefined";
